import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d4a94e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reset-success px-10 mb-20" }
const _hoisted_2 = { class: "reset-success__wrapper text-center pa-40" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-10" }, "Поздравляем", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-gradient text-center mb-20 d-inline-flex" }, "Спасибо, что обратился. В течении 24 часов твой пароль будем заменен. Отправим его тебе на электронную почту", -1))
const _hoisted_5 = { class: "reset-success__actions" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "d-inline-flex mt-40" }, "Будь в курсе новостей!", -1))

import BaseButton from '@/components/Buttons/BaseButton.vue'
import GradientLine from '@/components/Lines/GradientLine.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ResetSuccessView',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(GradientLine),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, { to: {name: 'home'} }, {
            default: _withCtx(() => [
              _createVNode(BaseButton, {
                class: "large rounded margin-auto mb-20 full-width",
                bg: "none",
                border: "default"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("На главную")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: {name: 'profile'} }, {
            default: _withCtx(() => [
              _createVNode(BaseButton, {
                class: "large rounded margin-auto mb-20 full-width",
                bg: "gradient",
                border: "gradient"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("личный кабинет")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _hoisted_6,
        _createVNode(BaseButton, {
          class: "large rounded margin-auto my-20 full-width",
          bg: "none",
          border: "default"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Подписаться в Телеграм")
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})